import { InjectionToken } from '@angular/core';

const defaultModuleConfig = {
    ignorePageTitleCalls: false,
    titleTextFormatFunction: null,
};
/**
 * Token used for providing the IPageTitlesModuleConfig
 * @example
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: PageTitlesModuleConfigToken, useValue: pageTitlesModuleConfig },
 * ],
 */
const PageTitlesModuleConfigToken = new InjectionToken('page_title_module_config');

/**
 * Generated bundle index. Do not edit.
 */

export { PageTitlesModuleConfigToken, defaultModuleConfig };

//# sourceMappingURL=mt-ng2-page-titles-config.js.map